<template>
  <div class="ivu-tabs-bar" :class="{'ivu-tabs-bar-scroll': scrollFlag}">
    <div class="ivu-tabs-bar-scroll-ope ivu-tabs-bar-scroll-prev"
      v-if="scrollFlag"
      @click.stop="scrollTab('prev')">
      <i class="yjh-icon icon-prev"></i>
    </div>
    <div class="ivu-tabs-bar-scroll-ope ivu-tabs-bar-scroll-next"
      v-if="scrollFlag"
      @click.stop="scrollTab('next')">
      <i class="yjh-icon icon-next"></i>
    </div>
    <div tabindex="0" class="ivu-tabs-nav-container">
      <div class="ivu-tabs-nav-wrap"  ref="tabWrapper" style="position: relative;">
        <div class="ivu-tabs-nav" ref="tabNav" v-show="tabs.length !== 0">
          <div class="ivu-tabs-tab"
            ref="tabItem"
            :class="{'ivu-tabs-tab-active': nowTab === tab.linkName }"
            v-for="tab in tabs"
            :key="tab.linkName"
            :label="tab.text"
            :name="tab.linkName"
            @click.stop="gotoTab(tab.linkName)"
          >
          {{tab.text}}
          <span v-if="tab.num !== undefined"> ({{tab.num}})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 如果isParams不是true，默认按照linkName去跳转
// 如果isParams是true，一定要有paramsLabel，按照paramsLabel匹配路由的params跳转
export default {
  data() {
    return {
      firstIndex: 0, // 最左侧是第几个index
      tabWidth: [], // 每个tab的宽度
      scrollWidth: 0, // 最大可滚动宽度
      left: 0,
      scrollFlag: false
    }
  },
  props: {
    tabs: Array,
    nowTab: String,
    isParams: Boolean,
    paramsLabel: String
  },
  mounted() {
    this.setScroll()
  },
  watch: {
    tabs: {
      handler: function() {
        this.setScroll()
      },
      deep: true
    }
  },
  methods: {
    // 判断是否需要加左右滚动
    setScroll() {
      this.$nextTick(() => {
        this.scrollWidth = this.$refs.tabNav.offsetWidth - this.$refs.tabWrapper.offsetWidth
        if (this.$refs.tabWrapper.offsetWidth < this.$refs.tabNav.offsetWidth) {
          this.tabWidth = Array(this.$refs.tabItem.length)
          let tmpW = 0
          this.$refs.tabItem.map((item, index) => {
            this.tabWidth[index] = tmpW
            tmpW += item.offsetWidth + 66
          })
          this.scrollFlag = true
        }
      })
    },
    // 超长滚动
    scrollTab(type) {
      if (type === 'next') {
        if (this.tabWidth[this.firstIndex + 1] > this.scrollWidth) {
          let flag = false
          this.tabWidth.some((item, index) => {
            if (!flag && item >= this.left && index !== 0) {
              flag = true
              this.left = item
              this.firstIndex = index + 1
            }
            return item > this.left
          })
          this.$refs.tabNav.style.transform = 'translate(-' + (this.scrollWidth + 10) + 'px)'
          setTimeout(() => {
            this.$refs.tabNav.style.transform = 'translate(-' + this.scrollWidth + 'px)'
          }, 500)
        } else {
          this.firstIndex++
          this.left = this.tabWidth[this.firstIndex]
          this.$refs.tabNav.style.transform = 'translate(-' + this.left + 'px)'
        }
      } else if (type === 'prev') {
        if (this.tabWidth[this.firstIndex - 1] === 0 || this.firstIndex <= 0) {
          this.firstIndex = 0
          this.left = 0
          this.$refs.tabNav.style.transform = 'translate(10px)'
          setTimeout(() => {
            this.$refs.tabNav.style.transform = 'translate(0)'
          }, 500)
        } else {
          this.firstIndex--
          this.left = this.tabWidth[this.firstIndex]
          this.$refs.tabNav.style.transform = 'translate(-' + this.left + 'px)'
        }
      }
    },
    // 跳转
    gotoTab(tab) {
      if (this.isParams === undefined || !this.isParams) {
        this.$router.push({ name: tab })
      } else {
        const jumpLink = {
          name: this.$route.name,
          params: {}
        }
        jumpLink.params[this.paramsLabel] = tab
        this.$router.push(jumpLink)
      }
    }
  }
}
</script>
